__turbopack_context__.v({
  "breadcrumbs": "rule-view-module__J7Wuta__breadcrumbs",
  "children": "rule-view-module__J7Wuta__children",
  "source": "rule-view-module__J7Wuta__source",
});
